import Spinner from '../Spinner/Spinner';
import styles from './SpinnerOverlay.module.scss';

interface ISpinnerOverlayProps {
  label?: string;
}

function SpinnerOverlay({ label }: ISpinnerOverlayProps) {
  return (
    <div className={styles.overlay}>
      {label || 'Saving'}
      <Spinner />
    </div>
  );
}

export default SpinnerOverlay;
